import i18n from './i18n';
import { normalizeAppLanguage } from './languageConstants';

/** FMS layout 조회 locale. en-US 같이 와도 en, 그 외는 ko. */
export function getFmsLayoutLocale(lang) {
  return normalizeAppLanguage(lang ?? i18n.language) || 'ko';
}

/**
 * 화면 언어를 FMS layout 조회 GET에 실을지 여부.
 * /api/layout/template/active, /api/layout/template/{uid}(data 제외), /api/objects/{key}/layout-config
 */
export function isFmsLayoutLocaleGetRequest(url, method) {
  const m = String(method || 'get').toLowerCase();
  if (m !== 'get' || !url) return false;
  const path = String(url).split('?')[0];
  if (path.includes('/api/layout/template/active')) return true;
  if (path.includes('/layout-config')) return true;
  return /\/api\/layout\/template\/[^/]+$/.test(path);
}
